import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IAppOnlyStore } from '../../stores';
import AnimateHeight from 'react-animate-height';
import { LoadingSpinner } from '../../components/indicator';
import { ConfigurationSetting } from './ConfigurationSetting';

// Styles
const s = require('./Configuration.css');

// Component
@inject('store')
@observer
export class Configuration extends React.Component<IAppOnlyStore, {}> {
    constructor(props: IAppOnlyStore) {
        super(props);

        // Fetch settings
        this.props.store.configuration.fetchSettings();
    }

    render() {
        const { configuration } = this.props.store;

        return (
            <div className={s.container}>
                <AnimateHeight height={configuration.loading ? 'auto' : 0}>
                    <LoadingSpinner active={configuration.loading} />
                </AnimateHeight>

                {configuration.loading === false &&
                    configuration.settings.map(setting => {
                        return (
                            <ConfigurationSetting
                                key={setting.key}
                                settingKey={setting.key}
                                value={setting.value}
                                description={setting.description}
                                isRequired={setting.isRequired}
                                status={setting.status}
                            />
                        );
                    })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/admin/Configuration.tsx